module.exports = __WEBPACK_EXTERNAL_MODULE_140__;


//////////////////
// WEBPACK FOOTER
// external "platformsh-client"
// module id = 140
// module chunks = 0